
















import { defineComponent, reactive, SetupContext } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { getEntityStorePath } from '@/store/entityModules/utils';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { useStore } from '@/components/composables/useStore';

const Component = defineComponent({
  name: 'ProductCategoryAttributesTable',

  components: {
    EntityTable,
  },

  setup(props: any, { root: { $router } }: SetupContext) {
    const store: Store<RootState> = useStore();
    const entityType = EntityType.PRODUCT_CATEGORY_ATTRIBUTE;
    const storePath = getEntityStorePath(entityType);

    store.dispatch(`${storePath}/setQuerySorting`, {
      sortBy: 'from',
      descending: 0,
    });

    const state = reactive({
      headers: [
        { text: 'Title', value: 'title', sortable: true },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Override in Product', value: 'overrideInProduct', sortable: false },
        { text: 'Default value', value: 'value', sortable: false },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
      selectedTab: 'attributes',
    });

    function reditectToOptions() {
      $router.push('options');
    }

    return {
      entityType,
      state,
      reditectToOptions,
    };
  },
});
export default Component;
